import { Location } from "pwapi";

import { shallowLeftDiff } from "shared/utils/formUtils";

export const submissionFieldsForLocation = (
  location: Location,
  values?: Partial<Location>
) => {
  if (!values) values = location;

  return {
    street: values.street || null,
    street2: values.street2 || null,
    phone1: values.phone1 || null,
    phone2: values.phone2 || null,
    city: values.city || null,
    state: values.state || null,
    zipcode: values.zipcode || null,
  };
};

export const shallowLocationComparison = (
  location: Location,
  values: Partial<Location>
) => {
  const oldValues = submissionFieldsForLocation(location);
  const newValues = submissionFieldsForLocation(location, values);

  return shallowLeftDiff<ReturnType<typeof submissionFieldsForLocation>>(
    oldValues,
    newValues
  );
};
